import { useQuery } from 'react-query'
import { axios } from 'lib'

type ResolveQuantityParams = {
  productId: string
  configurationFormValues: Record<string, any>
  quantityUn: number
}

type Response = {
  data: {
    quantity: number | null
  }
}

const resolveQuantityExpression = (
  data: ResolveQuantityParams
): Promise<Response> => {
  return axios.post('/orders/products/resolve-quantity', data)
}

export function useResolveQuantityExpression(params: ResolveQuantityParams) {
  return useQuery(
    [
      'resolveQuantityExpression',
      params.productId,
      params.quantityUn,
      JSON.stringify(params.configurationFormValues)
    ],
    () => resolveQuantityExpression(params),
    {
      enabled:
        !!params.productId &&
        !!params.quantityUn &&
        !!Object.keys(params.configurationFormValues || {}).length
    }
  )
}
